import React from "react";
import DownArrowicon from "../assets/icons/chevron-down.svg";
import RightArrowicon from "../assets/icons/chevron-right.svg";

const ArrowToggleBtn = ({open,onClick}) => {

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={open}
      className={`rounded-full flex justify-center items-center transition-all duration-300 cursor-pointer hover:scale-105
        ${open
          ? "w-10 h-10 bg-gradient-to-b from-[#B20925] to-[#82091D]"
          : "w-8 h-8 bg-white"}
      `}
    >
      <img
        src={open ? DownArrowicon : RightArrowicon}
        alt={open ? "Down arrow" : "Right arrow"}
        className={open?"w-6 h-6":"w-4 h-4"}
      />
    </button>
  );
};

export default ArrowToggleBtn;
